import { useCallback } from "react";
import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import { useOpenAgentChat } from "web_myplann/Shared/Hooks/useOpenAgentChat";
import { getAgentChatTitle } from "web_myplann/Shared/Utils/getAgentChatTitle";

export const useGoalAdvisorChat = (goal: GoalDetail | undefined) => {
	const { data: agent } = useAgentQuery(goal?.agent?.id);
	const openAgentChat = useOpenAgentChat();

	return useCallback(
		(message: string) =>
			openAgentChat({
				uid: agent?.uid,
				title: getAgentChatTitle(agent ?? goal?.agent),
				conversationId: agent?.conversationId,
				message,
			}),
		[agent, goal?.agent, openAgentChat],
	);
};
